import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is kgm/s2
export const Force: BaseQuantity = {
  id: "001force",
  name: "force",
  type: "numeric",
  value: "",
  symbol: "F",
  baseUnit: "N",
  selectedUnit: "N",
  units: [
    { name: "N", fromConst: 1, toConst: 1 },
    { name: "kN", fromConst: 10 ** 3, toConst: 1 / 10 ** 3 },
    { name: "MN", fromConst: 10 ** 6, toConst: 1 / 10 ** 6 },
    { name: "lbf", fromConst: 4.448, toConst: 1 / 4.448 },
  ],
};
